import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RepeatIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_711_3924)">
        <path
          d="M9.75 16.5L7.5 14.25M7.5 14.25L9.75 12M7.5 14.25H11.25C14.1495 14.25 16.5 11.8995 16.5 9C16.5 6.9057 15.2737 5.09782 13.5 4.25522M4.5 13.7448C2.72629 12.9022 1.5 11.0943 1.5 9C1.5 6.10051 3.85051 3.75 6.75 3.75H10.5M10.5 3.75L8.25 1.5M10.5 3.75L8.25 6"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_711_3924">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default RepeatIcon;
